import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  textWrapper: {
    position: 'relative'
  },
  outline: ({ outlineColor, outlineWidth }) => ({
    userSelect: 'none',
    WebkitTextStroke: `${outlineWidth || 6}px ${outlineColor || theme.palette.background.dark}`,
    position: 'absolute',
    transform: 'translate(-50%, -50%)'
  }),
  text: ({ textColor }) => ({
    color: textColor || theme.palette.text.primary,
    position: 'absolute',
    transform: 'translate(-50%, -50%)'
  })
}));

export default function OutlinedText({ text, outlineColor, outlineWidth, textColor, className }) {
  const classes = useStyles({ outlineColor, outlineWidth, textColor });

  return (
    <div className={clsx(classes.textWrapper, className)}>
      <Typography className={classes.outline}>{text}</Typography>
      <Typography className={classes.text}>{text}</Typography>
    </div>
  );
}
